import React from "react";
import PacmanLoader from "react-spinners/PacmanLoader";

const Spinner = () => {
  return (
    <div>
      <PacmanLoader color="#36d7b7" />
    </div>
  );
};

export default Spinner;
